module.exports = __webpack_public_path__ + "assets/glyphicons-halflings-regular.89889688147bd7575d6327160d64e760.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap-css-only/fonts/glyphicons-halflings-regular.svg
 ** module id = 451
 ** module chunks = 1
 **/